import { ResidentialStatus } from 'src/modules/personalLoan/constants';

export enum GENDER {
  Male = 'M',
  Female = 'F',
  Others = 'T',
}

export enum EMPLOYMENT_TYPES {
  Salaried = 'Salaried',
  Other = 'SelfEmployed',
  Housewife = 'Housewife',
  Retired = 'Retired',
  Student = 'Student',
}

export enum ACCOUNT_TYPE {
  Savings = 'Saving',
  Current = 'Current',
}

export enum ADDRESS_TYPE {
  Current = 'Current',
  Permanent = 'Permanent',
}

export enum SALARY_METHOD_TYPE {
  Cash = 'Cash',
  BankTransfer = 'BankTransfer',
  Cheque = 'Cheque',
}

export enum RESIDENTIAL_STATUS_TYPE {
  Owner = 'own',
  Rented = 'rented',
  PG = 'PG',
  Parents = 'staying with parents',
  Others = 'others',
}

export const AddressTypeOptions = [
  {
    name: 'Current',
    value: ADDRESS_TYPE.Current,
  },
  {
    name: 'Permanent',
    value: ADDRESS_TYPE.Permanent,
  },
];

export const EmploymentTypeOptions = [
  {
    name: 'Salaried',
    value: EMPLOYMENT_TYPES.Salaried,
  },
  {
    name: 'Self Employed',
    value: EMPLOYMENT_TYPES.Other,
  },
  {
    name: 'Housewife',
    value: EMPLOYMENT_TYPES.Housewife,
  },
  {
    name: 'Retired',
    value: EMPLOYMENT_TYPES.Retired,
  },
  {
    name: 'Student',
    value: EMPLOYMENT_TYPES.Student,
  },
  {
    name: 'Other',
    value: EMPLOYMENT_TYPES.Other,
  },
];

export const SalaryMethodTypeOptions = [
  {
    name: 'Cash',
    value: SALARY_METHOD_TYPE.Cash,
  },
  {
    name: 'Bank transfer',
    value: SALARY_METHOD_TYPE.BankTransfer,
  },
  {
    name: 'Cheque',
    value: SALARY_METHOD_TYPE.Cheque,
  },
];

export const ResidentialStatusTypeOptions = [
  {
    name: 'Owner',
    value: RESIDENTIAL_STATUS_TYPE.Owner,
  },
  {
    name: 'Rented',
    value: RESIDENTIAL_STATUS_TYPE.Rented,
  },
  {
    name: 'PG',
    value: RESIDENTIAL_STATUS_TYPE.PG,
  },
  {
    name: 'Staying with parents',
    value: RESIDENTIAL_STATUS_TYPE.Parents,
  },
  {
    name: 'Other',
    value: RESIDENTIAL_STATUS_TYPE.Others,
  },
];

export const PersonalDetailsForm = {
  fullName: { input: '', err: '' },
  email: { input: '', err: '' },
  dob: { input: '', err: '' },
  pan: { input: '', err: '' },
  gender: { input: GENDER.Male, err: '' },
  residential_status: { input: '', err: '' },
  pincode: { input: '', err: '' },
};

export const BankDetailsForm = {
  accountNo: { input: '', err: '' },
  ifsc: { input: '', err: '' },
  accHolderName: { input: '', err: '' },
  bankName: { input: '', err: '' },
  accType: { input: ACCOUNT_TYPE.Savings, err: '' },
  branch: { input: '', err: '' },
};

export const AddressDetailsForm = {
  addressType: { input: '', err: '' },
  address1: { input: '', err: '' },
  address2: { input: '', err: '' },
  landmark: { input: '', err: '' },
  pincode: { input: '', err: '' },
  city: { input: '', err: '' },
  state: { input: '', err: '' },
  residentialStatus: { input: '', err: '' },
};

export const ProfessionalDetailsForm = {
  company: { input: '', err: '' },
  designation: { input: '', err: '' },
  salary: { input: '', err: '' },
  empolymentType: { input: EMPLOYMENT_TYPES.Salaried, err: '' },
  salaryMethod: { input: SALARY_METHOD_TYPE.BankTransfer, err: '' },
};
